import React from 'react';
import PropTypes from 'prop-types';
import {BASE_TEXT, WEIGHT} from '../../../style/typography';
import {FOCUS_BLUE} from '../../../style/colors';
import {ROW, COLUMN, ORIENTATION_MARGIN} from '../../../style/orientations';
import glamorous from 'glamorous';

export const SMALL = 'small';
export const LARGE = 'large';
export {ROW, COLUMN};

const DIMENSIONS = {
  [SMALL]: 26,
  [LARGE]: 62
};

const MARGIN = 10;

const Container = glamorous.div(
  {
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center'
  },
  ({orientation}) => ({
    flexDirection: orientation
  })
);

const Button = glamorous.div(
  {
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer'
  },
  ({backgroundColor, size}) => ({
    height: DIMENSIONS[size],
    width: DIMENSIONS[size],
    backgroundColor
  })
);

const Description = glamorous.div(
  {
    ...BASE_TEXT,
    fontSize: 12,
    fontWeight: WEIGHT.BOLD
  },
  ({fontColor, orientation}) => ({color: fontColor, [ORIENTATION_MARGIN[orientation]]: MARGIN})
);

const FloatingActionButton = ({
  icon,
  backgroundColor = FOCUS_BLUE,
  fontColor = FOCUS_BLUE,
  description,
  orientation = COLUMN,
  size = LARGE,
  onClick,
  dataTestId = ''
}) => (
  <Container
    data-testid={dataTestId}
    orientation={orientation}
    onClick={() => onClick && onClick()}
  >
    <Button size={size} backgroundColor={backgroundColor}>
      {icon ? icon : null}
    </Button>
    <Description fontColor={fontColor} orientation={orientation}>
      {description}
    </Description>
  </Container>
);

FloatingActionButton.propTypes = {
  icon: PropTypes.element,
  backgroundColor: PropTypes.string,
  fontColor: PropTypes.string,
  description: PropTypes.string,
  size: PropTypes.oneOf([SMALL, LARGE]),
  orientation: PropTypes.oneOf([ROW, COLUMN]),
  onClick: PropTypes.func,
  dataTestId: PropTypes.string
};

export default FloatingActionButton;
